import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import identity from 'lodash/identity';
import assoc from 'lodash/fp/assoc';

import { createAuthToolsMiddlewares } from '@nerdwallet/js-auth-tools/middleware';
import appConfig from '@nerdwallet/app-config';

import nwApiSDK from './nw-api-sdk';
import rootReducer from './reducers';
import builderMiddleware from '../containers/builder/middleware';
import { EDITOR_UPDATE_DOCK } from '../containers/builder/actions';

const DOCK_PATH = 'builder.editor.dock';

const dockMiddleware = () => (next) => (action) => {
  if (process.env.IN_BROWSER) {
    // Remember dock position
    if (action.type === EDITOR_UPDATE_DOCK) {
      localStorage.setItem(DOCK_PATH, action.dock);
    }
  }
  return next(action);
};

const authToolsMiddlewares = createAuthToolsMiddlewares({
  asyncOptions: {
    IdentitySDK: nwApiSDK.IdentitySDK,
    identityProfilesToInclude: nwApiSDK.IdentityProfilesToInclude,
    identityApp: nwApiSDK.IdentitySDK.APPS.NERDWALLET_WEB,
  },
  // *OPTIONAL* Tracking for JS Auth Tools related actions. Uncomment the `metricsOptions` block to
  // enable tracking
  // metricsOptions: {
  //   // optionally you can pass an arbitrary appName here to "namespace" identity-related events
  //   // in amplitude. You can use your client id defined in the previous step
  //   appName: 'YOUR_UNIQUE_CLIENT_ID',
  //   // optionally pass trk params that will be passed with all js auth tools events:
  //   // https://nerdwallet.atlassian.net/wiki/display/PRODUCT/How+To%3A+Track+Registration+Flows+as+a+Vertical
  //   trk: {}
  // },
});

const middlewares = [
  thunkMiddleware,
  builderMiddleware,
  dockMiddleware,
  ...authToolsMiddlewares,
];

/* istanbul ignore next: see https://github.com/NerdWallet/review-client/pull/348 */
const devInClient = appConfig.NODE_ENV === 'development' && process.browser;

const hydrateFromLocalStorage = appConfig.IN_BROWSER
  ? assoc(DOCK_PATH, localStorage.getItem(DOCK_PATH) || 'left')
  : identity;

const devTools =
  devInClient && window.devToolsExtension
    ? window.devToolsExtension()
    : identity;

const createStoreWithMiddleware = compose(
  applyMiddleware(...middlewares),
  devTools
)(createStore);

export default (initialState) =>
  createStoreWithMiddleware(rootReducer, hydrateFromLocalStorage(initialState));
